import React from "react";
import { object } from "prop-types";

import { EntityLanding } from "../../molecules/entity-landing";
import { STATIC_KEYWORDS } from "../../../constants";

export const AllCompanies = ({ data, config }) => {
  return (
    <EntityLanding
      data={data}
      page="companies"
      headline={STATIC_KEYWORDS.ALL_COMPANIES}
      placeholder="Search Companies"
      config={config}
    />
  );
};

AllCompanies.propTypes = {
  data: object,
};
